import React, { useEffect } from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './style.less';

const formLayout = {
  labelCol: {
    span: 6,
  },
  layout: 'vertical',
  wrapperCol: {
    span: 18,
  },
};

function AddEditMemberModal({ visible, member, onSave, onDelete, onCancel, form }) {
  const { t } = useTranslation();
  const { getFieldDecorator, validateFields, setFieldsValue, resetFields } = form;

  const isEditing = !!member;
  const isPathwayAssignedRole = member?.createdByType === 'pathway_assignment';
  const hasRole = !!member?.roleId;
  const canDelete = isEditing && hasRole && !isPathwayAssignedRole;

  useEffect(() => {
    if (visible && member) {
      setFieldsValue({
        roleName: member.roleName || '',
        roleDescription: member.roleDescription || '',
        name: member.name || '',
        email: member.email || '',
        phone: member.phone || '',
        businessName: member.businessName || '',
      });
    } else if (visible && !member) {
      resetFields();
    }
  }, [visible, member, setFieldsValue, resetFields]);

  const handleSubmit = e => {
    e.preventDefault();
    validateFields((err, values) => {
      if (!err) {
        onSave({
          name: values.name || '',
          email: values.email || '',
          phone: values.phone || '',
          businessName: values.businessName || '',
          roleName: values.roleName,
          roleDescription: values.roleDescription || '',
        });
      }
    });
  };

  const handleDelete = () => {
    onDelete(member);
  };

  return (
    <Modal
      title={t(
        isEditing
          ? 'cards:CareTeamMembers.modal.editTitle'
          : 'cards:CareTeamMembers.modal.addTitle',
      )}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      className="add-edit-member-modal"
    >
      {isPathwayAssignedRole && (
        <p className="member-from-pathway-text">
          {t('cards:CareTeamMembers.modal.roleFromPathway', {
            pathwayName: member?.pathwayName || member?.roleName || '',
          })}
        </p>
      )}
      <Form {...formLayout} onSubmit={handleSubmit}>
        <Form.Item label={t('cards:CareTeamMembers.modal.form.roleName')}>
          {getFieldDecorator('roleName', {
            rules: [
              {
                required: true,
                message: t('cards:CareTeamMembers.modal.form.roleNameRequired'),
              },
            ],
          })(<Input type="text" disabled={hasRole || isPathwayAssignedRole} />)}
        </Form.Item>

        <Form.Item label={t('cards:CareTeamMembers.modal.form.roleDescription')}>
          {getFieldDecorator('roleDescription')(
            <Input type="text" disabled={hasRole || isPathwayAssignedRole} />,
          )}
        </Form.Item>

        <Form.Item label={t('cards:CareTeamMembers.modal.form.name')}>
          {getFieldDecorator('name')(<Input type="text" />)}
        </Form.Item>

        <Form.Item label={t('cards:CareTeamMembers.modal.form.email')}>
          {getFieldDecorator('email', {
            rules: [
              {
                type: 'email',
                message: t('cards:CareTeamMembers.modal.form.emailInvalid'),
              },
            ],
          })(<Input type="email" />)}
        </Form.Item>

        <Form.Item label={t('cards:CareTeamMembers.modal.form.phone')}>
          {getFieldDecorator('phone', {
            rules: [
              {
                pattern: /\+[\d\s]+/,
                message: t('cards:CareTeamMembers.modal.form.phoneInvalid'),
              },
            ],
          })(<Input type="tel" />)}
        </Form.Item>

        <Form.Item label={t('cards:CareTeamMembers.modal.form.businessName')}>
          {getFieldDecorator('businessName')(<Input type="text" />)}
        </Form.Item>

        <div className="modal-footer">
          {isEditing && (
            <Button
              type="danger"
              onClick={handleDelete}
              disabled={!canDelete}
              style={{ marginRight: 'auto' }}
            >
              {t('cards:CareTeamMembers.modal.delete')}
            </Button>
          )}
          <div style={{ marginLeft: 'auto' }}>
            <Button onClick={onCancel} style={{ marginRight: '10px' }}>
              {t('cards:CareTeamMembers.modal.cancel')}
            </Button>
            <Button type="primary" htmlType="submit">
              {t('cards:CareTeamMembers.modal.save')}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
}

const WrappedAddEditMemberModal = Form.create()(AddEditMemberModal);
export default WrappedAddEditMemberModal;
